import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { LiveCode } from "../components/code";
export const _frontmatter = {
  "title": "Cards"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`Cards`}</h1>
    <p>{`Examples of combining `}<inlineCode parentName="p">{`@theme-ui/components`}</inlineCode>{` to create and style cards.`}</p>
    <hr></hr>
    <h2>{`Vertical Stack`}</h2>
    <p>{`Vertical stacked card content.`}</p>
    <LiveCode containerSx={`sx={{display: 'grid', maxWidth: '420px', margin: '0 auto', p: '3' }}`} mdxType="LiveCode">{`<Card sx={{ borderRadius: '3', boxShadow: '0 8px 16px -4px rgba(0,0,0,.1), 0 0 8px -3px rgba(0,0,0,.1)', }}>
  <Image src={beach} sx={{ borderTopLeftRadius: '3', borderTopRightRadius: '3' }} />
  <Box sx={{ p: '3' }}>
    <Heading as='h2' mb={2} >The Beach Front</Heading>
    <Text mb={3}>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatibus quia, nulla! Maiores et perferendis eaque, exercitationem praesentium nihil.</Text>
    <Flex>
      <Badge mr={1}>summer</Badge><Badge mr={1}>photography</Badge><Badge mr={1}>travel</Badge>
    </Flex>
  </Box>
</Card>`}</LiveCode>
    <h2>{`Horizontal Stack`}</h2>
    <p>{`Left aligned content in a wider displyed card.`}</p>
    <LiveCode containerSx={`sx={{display: 'grid', margin: '0 auto', maxWidth: '560px', p: '3' }}`} mdxType="LiveCode">{`<Card sx={{ borderRadius: '3', display: 'grid', gridTemplateColumns: '1fr 2fr',  border: '1px solid', borderColor: 'border', boxShadow: '0 8px 16px -4px rgba(0,0,0,.1)' }}>
  <Image src={beach} sx={{ height: '100%', objectFit: 'cover', borderTopLeftRadius: '3', borderBottomLeftRadius: '3' }}/>
  <Box sx={{ p: '3' }}>
    <Heading as='h2' mb={2} >The Beach Front</Heading>
    <Text mb={3}>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatibus quia, nulla! Maiores et perferendis eaque, exercitationem praesentium nihil.</Text>
    <Flex>
      <Badge mr={1}>summer</Badge><Badge mr={1}>photography</Badge><Badge mr={1}>travel</Badge>
    </Flex>
  </Box>
</Card>`}</LiveCode>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      